// @ts-nocheck
import * as Types from '../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type InternalUsersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type InternalUsersQuery = { __typename?: 'Query', internalUsers: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string, user: { __typename?: 'User', id: string } }> };


export const InternalUsersDocument = gql`
    query InternalUsers {
  internalUsers {
    id
    name
    avatar
    user {
      id
    }
  }
}
    `;

/**
 * __useInternalUsersQuery__
 *
 * To run a query within a React component, call `useInternalUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useInternalUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InternalUsersQuery, InternalUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InternalUsersQuery, InternalUsersQueryVariables>(InternalUsersDocument, options);
      }
export function useInternalUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InternalUsersQuery, InternalUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InternalUsersQuery, InternalUsersQueryVariables>(InternalUsersDocument, options);
        }
// @ts-ignore
export function useInternalUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InternalUsersQuery, InternalUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InternalUsersQuery, InternalUsersQueryVariables>;
export function useInternalUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InternalUsersQuery, InternalUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InternalUsersQuery | undefined, InternalUsersQueryVariables>;
export function useInternalUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InternalUsersQuery, InternalUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InternalUsersQuery, InternalUsersQueryVariables>(InternalUsersDocument, options);
        }
export type InternalUsersQueryHookResult = ReturnType<typeof useInternalUsersQuery>;
export type InternalUsersLazyQueryHookResult = ReturnType<typeof useInternalUsersLazyQuery>;
export type InternalUsersSuspenseQueryHookResult = ReturnType<typeof useInternalUsersSuspenseQuery>;
export type InternalUsersQueryResult = ApolloReactCommon.QueryResult<InternalUsersQuery, InternalUsersQueryVariables>;